const getStoredDashboardScreenshotSettingsKey = (dashboardId: string): Nullable<string> =>
  dashboardId ? `dashboardScreenshotSettings-${dashboardId}` : null;

export default getStoredDashboardScreenshotSettingsKey;
